var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrivingSkill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "driving_skill",
    "data-name": "driving skill",
    transform: "translate(-510 -234)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 52,
    height: 52,
    rx: 12,
    transform: "translate(510 234)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "driving",
    transform: "translate(122 -104)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 36,
    height: 36,
    transform: "translate(396 346)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16133",
    "data-name": "Group 16133",
    transform: "translate(217.536 -195.464)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_905",
    "data-name": "Ellipse 905",
    d: "M14.464,1.205A13.259,13.259,0,0,0,5.089,23.84,13.259,13.259,0,1,0,23.84,5.089a13.172,13.172,0,0,0-9.376-3.883m0-1.205A14.464,14.464,0,1,1,0,14.464,14.464,14.464,0,0,1,14.464,0Z",
    transform: "translate(182 545)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_907",
    "data-name": "Ellipse 907",
    d: "M3.214,1.205A2.009,2.009,0,1,0,5.223,3.214,2.011,2.011,0,0,0,3.214,1.205M3.214,0A3.214,3.214,0,1,1,0,3.214,3.214,3.214,0,0,1,3.214,0Z",
    transform: "translate(193.25 556.25)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27788",
    "data-name": "Path 27788",
    d: "M-1571.757,2699.8l-.07-1.2.035.6-.037-.6a15.336,15.336,0,0,0,5.178-1.731,15.028,15.028,0,0,1,6.3-1.263,15.052,15.052,0,0,1,5.227.708c.359.149.76.326,1.186.512,1.542.679,4.124,1.815,4.989,1.559l.342,1.156c-1.193.353-3.25-.482-5.816-1.611-.419-.185-.816-.359-1.163-.5-1.82-.756-7.388-1.05-10.53.521A16.067,16.067,0,0,1-1571.757,2699.8Z",
    transform: "translate(1756.377 -2141.278)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27789",
    "data-name": "Path 27789",
    d: "M-1562.461,2713.409c-.4-3.112-1.5-5.331-3.262-6.6a6.917,6.917,0,0,0-4.927-1.108l-.243-1.18a8.032,8.032,0,0,1,5.857,1.3c2.058,1.468,3.327,3.97,3.771,7.436Z",
    transform: "translate(1756.193 -2143.01)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27790",
    "data-name": "Path 27790",
    d: "M-1570.29,2713.41l-1.2-.153c.444-3.466,1.712-5.968,3.771-7.436a8.035,8.035,0,0,1,5.857-1.3l-.243,1.181a6.919,6.919,0,0,0-4.928,1.108C-1568.794,2708.078-1569.891,2710.3-1570.29,2713.41Z",
    transform: "translate(1769.167 -2143.01)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_906",
    "data-name": "Ellipse 906",
    d: "M12.054,1.205A10.848,10.848,0,0,0,4.383,19.725,10.848,10.848,0,1,0,19.725,4.383a10.777,10.777,0,0,0-7.671-3.177m0-1.205A12.054,12.054,0,1,1,0,12.054,12.054,12.054,0,0,1,12.054,0Z",
    transform: "translate(184.411 547.411)",
    fill: "#19bc9c"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrivingSkill);
export default __webpack_public_path__ + "static/media/drivingSkill.51f9dd01df4753fbc98f6e8aa200852d.svg";
export { ForwardRef as ReactComponent };